/**
 * Google Ads Conversion Tracking
 * Tracks key conversion events for Google Ads campaigns
 */

export const trackGoogleAdsConversion = (conversionId: string, value?: number, currency?: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'conversion', {
      'send_to': `AW-17947996665/${conversionId}`,
      ...(value && { 'value': value }),
      ...(currency && { 'currency': currency }),
    });
  }
};

/**
 * Track quote request submission
 */
export const trackQuoteRequest = () => {
  trackGoogleAdsConversion('quote_request', 1, 'USD');
  console.log('[Google Ads] Quote request conversion tracked');
};

/**
 * Track phone call click
 */
export const trackPhoneCall = () => {
  trackGoogleAdsConversion('phone_call', 1, 'USD');
  console.log('[Google Ads] Phone call conversion tracked');
};

/**
 * Track chat submission
 */
export const trackChatSubmission = () => {
  trackGoogleAdsConversion('chat_submission', 1, 'USD');
  console.log('[Google Ads] Chat submission conversion tracked');
};

/**
 * Track page view with custom parameters
 */
export const trackPageView = (pageName: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'page_view', {
      'page_title': pageName,
      'page_path': window.location.pathname,
    });
  }
};

/**
 * Track CTA button click
 */
export const trackCTAClick = (ctaName: string, location: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'cta_click', {
      'cta_name': ctaName,
      'cta_location': location,
    });
  }
};
